import * as React from 'react';
import './MobileLoginLayout.scss';

const MobileLoginLayout = (props) => {
  const { children } = props;
  return (
    <div className='mobile-login-layout'>
      <div>{children}</div>
    </div>
  );
};

export default MobileLoginLayout;
